import React, {useEffect, useState} from "react";
import {connect} from "react-redux";

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import LoaderContent from '../../../../design-system/components/Loader/LoaderContent';
import Toast from '../../../../design-system/components/Toast/Toast';
import TitleBanner from '../../../../design-system/components/Banners/TitleBanner';
import Details from "./Details";
import NewItem from "../Components/NewItem";
import BulkUploadPage from "./BulkUpload/BulkUploadPage";
import { useB2BPermissions } from '../../../../context/B2BPermissionsContext';
import { SCOPE_TYPES } from '../../../../utils/scopeType';

// @sdk
import {MembershipManagmentB2BService} from '@sdk-point/talisis'

//se crea la variable para el llamado
const MembershipManagmentB2BServiceSDK = new MembershipManagmentB2BService(process.env.REACT_APP_ENV_V2, process.env.REACT_APP_X_API_KEY_V2);

const AltaNew = (props) => {
    const { filterCompaniesByScope, assignedCompanyName, scopeTypes, autoSelectCompany } = useB2BPermissions();

    // "+ Nueva Empresa" se muestra cuando el usuario tiene configurado alcance
    // INTERNO. Se usa `scopeTypes` (los tipos CRUDOS configurados), NO `scopeType`
    // (el tipo efectivo para empresas): aunque en el caso internal + external las
    // empresas efectivas sean las de external, el botón debe seguir visible porque
    // el usuario SÍ tiene permiso interno. Solo se oculta si es exclusivamente
    // externo.
    const canCreateCompany = (scopeTypes || []).includes(SCOPE_TYPES.INTERNAL);
    const setShowTabs = props.setShowTabs || (() => {});
    const setBreadCrumbs = props.setBreadCrumbs || (() => {});

    const correo = [{id: 1, name: 'Si'}, {id: 2, name: 'No'},]

    const [openNewItemModal, setOpenNewItemModal] = useState(false);
    const [modal, setModal] = useState({})
    const [catalogues, setCatalogues] = useState({company: [], group: []});
    const [companySelected, setCompanySelected] = useState([]);
    const [groupSelected, setGroupSelected] = useState([]);
    const [atributeSelected, setAttributeSelected] = useState([]);
    const [loading, setLoading] = React.useState(false);
    const loadMessage = "";
    const [toastProps, setToastProps] = React.useState({
        message: "",
        open: false
    });
    const [uploadMode, setUploadMode] = useState('manual'); // 'manual' | 'bulk'

    const [form, setForm] = React.useState({});

    const getCompany = async () => {
        const response = await MembershipManagmentB2BServiceSDK.getCatalogCompanies({type: 'company'})
        if (response.success) {
            // Restrict to the user's configured companies, matched by display_name
            // (normalized) against the user's scope. Filtering on the raw catalog
            // items (which still carry display_name) before mapping.
            const scoped = filterCompaniesByScope(response.data || []);
            const company = scoped.map((item) => ({id: item.id, label: item.display_name, value: item.id, tag: item.tag}));

            setCatalogues(prevState => ({...prevState, company}))

            // Autoselección: cuando el usuario tiene UNA sola empresa externa, el
            // contexto entrega `autoSelectCompany`. Se precarga el formulario con esa
            // empresa y se cargan sus grupos/atributos, replicando lo que haría
            // handleChange('company_id'). El match es por nombre normalizado (el id
            // del scope no necesariamente coincide con el id del catálogo). Solo se
            // autoselecciona si el usuario aún no eligió empresa (form.company_id
            // vacío), para no pisar una selección manual.
            if (autoSelectCompany && !form.company_id) {
                const normalize = (n) => (n || '').toString().trim().toUpperCase();
                const match = company.find(
                    (c) => normalize(c.label) === normalize(autoSelectCompany.company_name)
                );
                if (match) {
                    setForm(prev => ({...prev, company_id: match.id}));
                    setCompanySelected(match);
                    await getGroup(match.id);
                    await getCustom(match.id);
                }
            }
        }
    }

    const getGroup = async (companyId) => {
        const groupData = await MembershipManagmentB2BServiceSDK.getCatalogCompanies({
            type: 'group',
            companyId
        });
        if (groupData.success) {
            let group = groupData.data.map((item) => ({id: item.id, label: item.display_name, value: item.id, tag: item.tag}));
            setCatalogues(prevState => ({...prevState, group}))
        }
    }
    const getCustom = async (companyId) => {
        const attributeData = await MembershipManagmentB2BServiceSDK.getCatalogCompanies({
            type: 'custom',
            companyId
        });
        if (attributeData.success && attributeData.data && attributeData.data.length > 0) {
            let attribute = attributeData.data.map((item) => ({
                id: item.id,
                label: item.display_name,
                value: item.id,
                tag: item.tag
            }));
            setAttributeSelected(attribute)
        } else {
            setAttributeSelected([]);
        }
    }

    // Re-run when the user's scope (assignedCompanyName) changes. The permissions
    // load is async and may resolve AFTER the first render; without this, the
    // company catalog would be filtered against an empty/partial scope and some
    // configured companies (e.g. a recently assigned one) would never appear.
    useEffect(() => {
        getCompany();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [assignedCompanyName.join('|')]);

    const handleFinishedToast = () => {
        setToastProps(prev => {
            return {...prev, open: false}
        });
    };

    const [openModal1, setOpenModal1] = useState(false);

    const handleUsersModal = async () => {
        // Validar los datos comunes requeridos antes de continuar. Se revisan
        // uno por uno para indicar al usuario exactamente qué campo falta.
        if (!form.company_id) {
            setToastProps({ open: true, severity: 'error', message: 'Seleccione una empresa.' });
            return;
        }
        if (!form.group_id) {
            setToastProps({ open: true, severity: 'error', message: 'Seleccione un grupo.' });
            return;
        }
        if (form.email === '' || form.email === undefined || form.email === null) {
            setToastProps({ open: true, severity: 'error', message: 'Seleccione si desea enviar correo.' });
            return;
        }

        // TODO: llamar los catalogos que usa el form altas usuarios   form
        setForm(prev => ({...prev, company: {...companySelected}, group: {...groupSelected}}))
        setBreadCrumbs(prev => ([...prev, {label: 'Alta', title: ''}]))
        setShowTabs(false)
        setOpenModal1(true)

    }

    const handleCompanyModal = () => {
        setModal({title: 'a Empresa', label: 'Empresa', name: 'company'})
        setOpenNewItemModal(true);
    }

    const handleGroupModal = () => {
        setModal({title: 'o Grupo', label: 'Grupo', name: 'group'})
        setOpenNewItemModal(true);
    }


    const handleCloseModal1 = () => {
        setShowTabs(true)
        setBreadCrumbs(prev => (prev.filter((item) => item.label !== 'Alta')))
        setOpenModal1(false)
    };

    const handleChange = async (e) => {
        let {name, value} = e.target;
        if (value === undefined) return;
        setLoading(true)
        setForm(prev => {
            return {...prev, [name]: value}
        });
        if (name === 'company_id' && name !== undefined) {
            let _companySelected = catalogues.company.find(item => item.id === value);
            setCompanySelected(_companySelected)
            await getGroup(value)
            await getCustom(value)
        }
        if (name === 'group_id' && name !== undefined) {
            let _groupSelected = catalogues.group.find(item => item.id === value);
            setGroupSelected(_groupSelected)
        }
        setLoading(false)
    };

    const onCloseNewItemModal = () => setOpenNewItemModal(false)

    const handleSubmitForm = async (data) => {
        // Cerrar modal inmediatamente
        setOpenNewItemModal(false);
        setLoading(true);

        let payload = {}
        let toastMessage = {severity: "success", open: true, message: 'El registro ha sido enviado exitosamente.'}
        if (data.type === 'company') {
            payload = {"tagType": "company", "displayName": data.value, "companyId": 0, "companyName": data.value}
        }
        if (data.type === 'group') {
            payload = {
                "tagType": "group",
                "displayName": data.value,
                "companyId": companySelected.id,
                "companyName": companySelected.label
            }
        }

        try {
            await MembershipManagmentB2BServiceSDK.postCreateCompanies(payload);
            if (data.type === 'company') {
                const response = await MembershipManagmentB2BServiceSDK.getCatalogCompanies({type: 'company'});
                if (response && response.success && response.data) {
                    let company = response.data.map((item) => ({id: item.id, label: item.display_name, value: item.id, tag: item.tag}));
                    setCatalogues(prevState => ({...prevState, company}));
                    // Auto-seleccionar la nueva empresa
                    const newCompany = company.find(c => c.label === data.value);
                    if (newCompany) {
                        setForm(prev => ({...prev, company_id: newCompany.id}));
                        setCompanySelected(newCompany);
                    }
                }
            } else {
                const groupData = await MembershipManagmentB2BServiceSDK.getCatalogCompanies({type: 'group', companyId: companySelected.id});
                if (groupData && groupData.success && groupData.data) {
                    let group = groupData.data.map((item) => ({id: item.id, label: item.display_name, value: item.id, tag: item.tag}));
                    setCatalogues(prevState => ({...prevState, group}));
                    // Auto-seleccionar el nuevo grupo
                    const newGroup = group.find(g => g.label === data.value);
                    if (newGroup) {
                        setForm(prev => ({...prev, group_id: newGroup.id}));
                        setGroupSelected(newGroup);
                    }
                }
            }
        } catch (e) {
            toastMessage = {severity: "error", open: true, message: 'Ocurrió un error. Por favor inténtalo de nuevo.'};
        }
        setToastProps({...toastMessage});
        setLoading(false);
    }

    return (
        <Grid container spacing={2}>
            {!openModal1 && (
                <>
                    <Grid item xs={12}>
                        <TitleBanner
                            title="Gestión de Membresías B2B - Altas"
                            desc="Complete los datos comunes para crear nuevas membresías B2B."
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6" className={'mb-3'} style={{fontWeight: 600}}>Datos Comunes</Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            name="company_id"
                                            label="Seleccione una empresa"
                                            required
                                            select
                                            fullWidth
                                            variant="outlined"
                                            margin="dense"
                                            value={form.company_id || ""}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            onChange={handleChange}
                                            disabled={loading}
                                        >
                                            {catalogues.company.map(option => (
                                                <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                                            ))}

                                            {canCreateCompany && (
                                                <Box p={1} style={{ borderTop: '1px solid #eee' }}>
                                                    <Button 
                                                        size="small" 
                                                        variant="outlined" 
                                                        color="primary"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleCompanyModal();
                                                        }}
                                                    >
                                                        + Nueva Empresa
                                                    </Button>
                                                </Box>
                                            )}
                                        </TextField>


                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            name="group_id"
                                            label="Seleccione un grupo"
                                            required
                                            select
                                            fullWidth
                                            variant="outlined"
                                            margin="dense"
                                            value={form.group_id || ""}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            disabled={loading}
                                            onChange={handleChange}

                                        >
                                            {catalogues.group.map(option => (
                                                <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                                            ))}

                                            <Box p={1}>
                                                <Button 
                                                    size="small" 
                                                    variant="outlined" 
                                                    color="primary"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleGroupModal();
                                                    }}
                                                >
                                                    Nuevo Grupo
                                                </Button>
                                            </Box>
                                        </TextField>

                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            name="email"
                                            label="Seleccione enviar correo"
                                            required
                                            select
                                            fullWidth
                                            variant="outlined"
                                            margin="dense"
                                            value={form.email || ""}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            disabled={loading}
                                            onChange={handleChange}

                                        >
                                            {correo.map(option => (
                                                <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>

                                </Grid>
                                <Grid item xs={12}>
                                    <Box mt={2} mb={2}>
                                        <Tabs
                                            value={uploadMode}
                                            onChange={(_, v) => setUploadMode(v)}
                                            indicatorColor="primary"
                                            textColor="primary"
                                        >
                                            <Tab value="manual" label="Manual" />
                                            <Tab value="bulk" label="Carga Masiva" />
                                        </Tabs>
                                    </Box>
                                </Grid>
                                {uploadMode === 'manual' && (
                                    <Box display="flex" justifyContent="flex-end" marginTop={3} width="100%">
                                        <Button 
                                            color="primary" 
                                            variant="contained"
                                            disabled={
                                                loading ||
                                                !form.company_id ||
                                                !form.group_id ||
                                                form.email === '' ||
                                                form.email === undefined ||
                                                form.email === null
                                            }
                                            onClick={handleUsersModal}
                                            size="large"
                                        >
                                            Continuar
                                        </Button>
                                    </Box>
                                )}
                                {uploadMode === 'bulk' && (
                                    <Box mt={2} width="100%" px={1}>
                                        <BulkUploadPage
                                            companySelected={companySelected}
                                            groupSelected={groupSelected}
                                            companyCatalog={catalogues.company}
                                            sendEmail={form.email === 1}
                                            emailSelected={form.email}
                                            onCompanyResolved={async (company) => {
                                                setForm(prev => ({ ...prev, company_id: company.id }));
                                                setCompanySelected(company);
                                                await getGroup(company.id);
                                                await getCustom(company.id);
                                            }}
                                        />
                                    </Box>
                                )}

                            </CardContent>
                        </Card>
                    </Grid>
                </>
            )}
            {openModal1 && (
                <Grid item xs={12}>
                    <Details dataGeneral={form} onClose={handleCloseModal1} dataAttribute={atributeSelected} cataloguesGroup={catalogues.group}/>
                </Grid>
            )}
            <LoaderContent loading={loading} message={loadMessage}>
                <NewItem
                    openModal={openNewItemModal}
                    handleClose={onCloseNewItemModal}
                    title={modal.title}
                    label={modal.label}
                    name={modal.name}
                    handleSubmit={handleSubmitForm}
                />
            </LoaderContent>
            <Toast {...toastProps} onFinished={handleFinishedToast} duration={3000}/>
        </Grid>
    );
}

const mapStateToProps = (reducers) => reducers.userReducer;

export default connect(mapStateToProps, {})(AltaNew);
